export default __webpack_public_path__ + "static/media/Footer.a2aba27d.png";